module.exports = __webpack_public_path__ + "static/media/placeholder-limited.b00643d9.jpg";